import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Login } from '../components/login/login';
import { AuthModel } from '../components/authorize/auth-model';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    apiUrl = environment.apiUrl

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private http: HttpClient,private _authservice:AuthService) { }

    loginWithProvinceCode(login: Login): Observable<AuthModel> {
        return this.http.post<AuthModel>(this.apiUrl + "videoStore/loginWithProvinceCode", login);
    }
    
    loginUsingAuthToken(login:Login):Observable<AuthModel>{
        console.log(login)
        return this.http.post<AuthModel>(this.apiUrl + "videoStore/loginWithToken", login);
    }

    logoutUser():Observable<any>
    {
        const token = this._authservice.getAuthToken();
        let params = new HttpParams();
        params = params.append("token",token)
        this._authservice.logout();
        return this.http.put(this.apiUrl + "logoutUser",null,{params:params});
    }
    
}